import axios from 'axios';

/**
 * Bare axios client for the anonymous public surface (Phase 7).
 *
 * Why separate from `api.js`:
 *   • The main api.js attaches an Authorization header from
 *     localStorage on every request. For public routes this is
 *     harmless (the backend ignores the bearer) but worse: a 401
 *     refresh-token race can fire from a stale token while
 *     viewing a public page, which is confusing and ends up
 *     forcing a login redirect on what should be an anonymous
 *     view.
 *   • Public errors should never trigger the auth-refresh
 *     interceptor — there's no token to refresh, and any 401
 *     from /api/public/* is a real "not visible" answer.
 *
 * Used exclusively by the pages under pages/public-league/.
 */
const publicApi = axios.create({
  baseURL: '/api/public',
  timeout: 12000,
  headers: { 'Content-Type': 'application/json' },
});

export default publicApi;
